import { Box, Text } from '@vouched.id/vault';
import React, { useMemo } from 'react';
import { Dropdown } from '../../Dropdown';
import { DropdownItemsSection } from '../../DropdownItemsSection';
import { addIconsToDropdownItems, DropdownItemTypes, DropdownStatusIcon, JobErrorMessage } from '../../utils';
import { SSNCaption } from '../SSNCaption';
import { ECBSVRequestDataTable } from './ECBSVRequestDataTable';
import { JobType } from 'components/account/jobs/job_type';
import { JobExecutionStatus } from 'models/jobs/shared';
export const ECBSVCompletedResult = ({ parentJobStatus, jobStatus, requestData, deathIndicator, verified }) => {
    const { dropdownHasWarnings, dropdownHasRejections, dropdownItems } = useMemo(() => {
        const dropdownItemsWithoutIcons = [
            {
                text: 'SSN Match',
                type: DropdownItemTypes.BooleanDropdownItem,
                value: verified,
                available: true,
                hasErrorOrWarning: {
                    hasError: !verified,
                    hasWarning: false
                }
            }
        ];
        return addIconsToDropdownItems(dropdownItemsWithoutIcons);
    }, [verified]);
    return (React.createElement(Dropdown, { statusIcon: React.createElement(DropdownStatusIcon, { dropdownHasRejections: dropdownHasRejections, dropdownHasWarnings: dropdownHasWarnings, jobStatus: jobStatus, parentJobStatus: parentJobStatus }), title: "SSN" },
        React.createElement(Box, null,
            React.createElement(SSNCaption, { type: JobType.ecbsvSSN }),
            jobStatus === JobExecutionStatus.Error ? (React.createElement(JobErrorMessage, { typeName: "ECBSV SSN verification" })) : (React.createElement(React.Fragment, null,
                React.createElement(DropdownItemsSection, { dropdownItems: dropdownItems }),
                React.createElement(Box, { display: "flex", style: { gap: '15px' } },
                    React.createElement(Text, null, "Death Indicator:"),
                    React.createElement(Text, { "data-ph-mask": true, style: { fontWeight: '600' } }, deathIndicator)),
                React.createElement(Box, { display: "flex", style: { gap: '15px' } },
                    React.createElement(Text, null, "Source:"),
                    React.createElement(Text, { style: { fontWeight: '600' } }, "eCBSV")),
                requestData && React.createElement(ECBSVRequestDataTable, { requestData: requestData }))))));
};
